const findLessonByLessonType = ({ lessons, lessonType }) => {
  if (!lessons) return null;

  return lessons.find((lesson) => lesson.lesson_type === lessonType);
};

export default findLessonByLessonType;
